import React from "react";

export function Button({ children, onClick, className, ...props }) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center rounded-xl bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 transition ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
